import { Map, List } from 'immutable';
import EmployeesConstants from 'Shared/constants/Employees.constants';
import { isEmpty } from 'lodash';

const initialState = Map({
  [EmployeesConstants.State.EMPLOYEES_EMAIL]: List(),
});

export const EmployeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case EmployeesConstants.Actions.GET_EMPLOYEES_EMAIL_SUCCESS:
      if (isEmpty(action.payload)) {
        return state;
      }
      return state.setIn([EmployeesConstants.State.EMPLOYEES_EMAIL], List(action.payload));
    default:
      return state;
  }
};
